// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Tx7y","title":"Header_title__61XlH","left":"Header_left__2upRn","clinicName":"Header_clinicName__2uyoI"};